import { render, staticRenderFns } from "./bkmvAddFamily.vue?vue&type=template&id=274fc1b9&scoped=true"
import script from "./bkmvAddFamily.vue?vue&type=script&lang=js"
export * from "./bkmvAddFamily.vue?vue&type=script&lang=js"
import style0 from "./bkmvAddFamily.vue?vue&type=style&index=0&id=274fc1b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274fc1b9",
  null
  
)

export default component.exports